import React, { useRef, useState } from 'react';
import { Camera } from 'lucide-react';
import PrimaryButton from './PrimaryButton';
import { convertHeicToJpeg, isHeicFile } from '../../utils/convertHeic';

// A labeled file input for uploading a single image. Used anywhere the user
// needs to attach a photo (plant photos, zone photos, journal entries).
// Calls `onPick(file)` when a file is chosen.
export default function PhotoUploader({
  onPick,
  label = 'Add photo',
  busy = false,
  variant = 'secondary',
  className = '',
  accept = 'image/*,image/heic,image/heif,.heic,.heif',
}) {
  const ref = useRef(null);
  const [fileName, setFileName] = useState(null);

  return (
    <div className={className}>
      <input
        ref={ref}
        type="file"
        accept={accept}
        className="hidden"
        onChange={async (e) => {
          let f = e.target.files?.[0];
          if (f) {
            if (isHeicFile(f)) {
              try {
                f = await convertHeicToJpeg(f);
              } catch (err) {
                alert(err.message || 'Could not convert HEIC image. Please try a JPG or PNG.');
                e.target.value = '';
                return;
              }
            }
            setFileName(f.name);
            onPick?.(f);
          }
          e.target.value = '';
        }}
      />
      <PrimaryButton
        variant={variant}
        onClick={() => ref.current?.click()}
        disabled={busy}
        className="w-full"
      >
        <Camera size={18} /> {busy ? 'Uploading…' : label}
      </PrimaryButton>
      {fileName && !busy ? (
        <div className="mt-1 text-[11px] text-garden-muted text-center truncate">
          {fileName}
        </div>
      ) : null}
    </div>
  );
}
